'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.convertFlatDataToTree = exports.getOptions = exports.disabledNodes = exports.convertOptions = undefined;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _language = require('../language');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var convertOptions = exports.convertOptions = function convertOptions(options, valueKey, labelKey) {
    if (!valueKey && !labelKey) {
        return;
    }
    _lodash2.default.each(options, function (item) {
        item.title = item[labelKey] || item.title;
        item.label = item[labelKey] || item.title;
        item.value = item[valueKey] ? item[valueKey].toString() : item[valueKey];
        if (_lodash2.default.isArray(item.children)) {
            convertOptions(item.children, valueKey, labelKey);
        }
    });
};

var disabledNodes = exports.disabledNodes = function disabledNodes(options, nodes) {
    _lodash2.default.each(options, function (item) {
        if (nodes.indexOf(item.value) >= 0) {
            item.disabled = true;
        }
        if (_lodash2.default.isArray(item.children)) {
            disabledNodes(item.children, nodes);
        }
    });
};

var getOptions = exports.getOptions = function getOptions(options, valueKey, labelKey, nodes) {
    convertOptions(options, valueKey, labelKey);
    if (!_lodash2.default.isEmpty(nodes)) {
        disabledNodes(options, nodes);
    }
    return options || [];
};

var convertFlatDataToTree = exports.convertFlatDataToTree = function convertFlatDataToTree(items) {
    var valueKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'id';

    var tree = [];
    var mappedArr = {};
    items.forEach(function (item) {
        mappedArr[item[valueKey]] = item;
        mappedArr[item[valueKey]].children = [];
    });

    for (var id in mappedArr) {
        var mappedElem = mappedArr[id];

        if (mappedElem.parentId) {
            var parentId = mappedElem.parentId;
            if (mappedArr[parentId]) {
                mappedArr[parentId].children.push(mappedElem);
            } else {
                console.log('parentId: ' + parentId + ' ' + (0, _language.t)('does not exist') + '.');
            }
        } else {
            tree.push(mappedElem);
        }
    }

    return tree;
};